import db from "src/db";
import { LCName, setItemLC } from "src/app/modules/localstorage";
import { startUserPresence } from "./userPresenceService";

const SESSION_UPDATE_TTL_MS = 60 * 1000;

const lastSessionUpdateByKey = new Map<string, number>();

const buildSessionKey = (uid: string, sessionId: string) =>
  `${uid}:${sessionId}`;

export const createSession = async (uid: string): Promise<string> => {
  const createdAt = Date.now();

  try {
    const docRef = await db.collection(`/users/${uid}/session`).add({
      created: createdAt,
      started: createdAt,
      screentime: 0,
      ended: 0,
    });

    setItemLC(LCName.SessionID, docRef.id);
    setItemLC(LCName.SessionCreated, createdAt);
    startUserPresence(uid, docRef.id);

    return docRef.id;
  } catch (error) {
    console.log(`firebase login error createSession ${error}`);
    return "";
  }
};

export async function updateSession(
  uid: string,
  sessionId: string,
  created: number
) {
  const key = buildSessionKey(uid, sessionId);
  const now = Date.now();
  const lastUpdateAt = lastSessionUpdateByKey.get(key);

  if (lastUpdateAt && now - lastUpdateAt < SESSION_UPDATE_TTL_MS) {
    return;
  }

  lastSessionUpdateByKey.set(key, now);

  const screentime = now - created;
  await db.collection(`/users/${uid}/session`).doc(sessionId).update({
    screentime,
    ended: now,
  });
}

export const saveUserSessionToken = async (
  uid: string,
  token: string
): Promise<string> => {
  try {
    await db.doc(`/users/${uid}`).update({
      sessiontoken: token,
    });
    setItemLC(LCName.SessionToken, token);
    return "success";
  } catch (error) {
    console.log(`firebase save user token error ${error}`);
    throw error;
  }
};

export const getUserSessionToken = async (uid: string): Promise<string> => {
  try {
    const snaps = await db.collection("users").doc(`${uid}`).get();
    return snaps.get("sessiontoken");
  } catch (error) {
    console.log(`firebase get user token error ${error}`);
    throw error;
  }
};

export const __resetSessionServiceForTest = () => {
  lastSessionUpdateByKey.clear();
};
